import { useNavigate, useParams } from 'react-router-dom';
import './BlogDetails.css';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import { useEffect, useState } from 'react';
import { Button, Flex, Loader, Stack, Badge, Title, Text, Container, Image } from '@mantine/core';
import { IconArrowLeft, IconCalendar, IconUser } from '@tabler/icons-react';
import axios from 'axios';
import { getRelativeDate } from '../../utils/getRelativeDate';

export default function BlogDetails() {
   const navigate = useNavigate();
   const { slugName } = useParams();

   const [state, setState] = useState({
      isLoading: false,
      error: false,
      data: null
   });

   useEffect(() => {
      const getPost = async () => {
         try {
            setState(prev => ({ ...prev, isLoading: true }));
            const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/blog/${slugName}?view=true`;
            const { data } = await axios.get(URL);
            setState(prev => ({ ...prev, data }));
         } catch (error) {
            setState(prev => ({ ...prev, error: true }));
         } finally {
            setState(prev => ({ ...prev, isLoading: false }));
         }
      };
      getPost();
   }, [slugName]);

   // Manejo de saltos de línea o párrafos
   const postParagraphs = state.data?.content?.split('\n').filter(p => p.trim() !== "");

   return (
      <MainLayout>
         <div className='BlogDetails-main-container'>

            {state.isLoading && (
               <Flex justify="center" align="center" h="50vh">
                  <Loader size="xl" variant="dots" />
               </Flex>
            )}

            {state.error && (
               <Text c="red" fz='var(--fs-body)' ta="center">Hubo un error al cargar el artículo. Intenta de nuevo.</Text>
            )}
           
            {state.data && !state.isLoading && (
               <>
                  <Flex justify='start'>
                     <Button
                        leftSection={<IconArrowLeft size={16} />}
                        variant='outline'
                        color="var(--color-text-primary)"
                        onClick={() => navigate(-1)}
                        className="back-button"
                     >
                        Volver
                     </Button>
                  </Flex>

                  <header className="BlogDetails-header">
                     {state.data.category && (
                        <Badge variant="filled" color="var(--color-tertiary)" mb="sm">
                           {state.data.category}
                        </Badge>
                     )}

                     <Title order={1} className='BlogPage--pageTitle'>
                        {state.data.title}
                     </Title>

                     <Flex gap="md" mt="md" wrap="wrap" className="BlogDetails-meta">
                        <Flex align="center" gap={5}>
                           <IconCalendar size={16} stroke={1.5} />
                           <Text fz='var(--fs-small)' c="var(--color-text-primary)">{getRelativeDate(state.data.date)}</Text>
                        </Flex>
                        {state.data.author && (
                           <Flex align="center" gap={5}>
                              <IconUser size={16} stroke={1.5} />
                              <Text fz='var(--fs-small)' c="var(--color-text-primary)">Por <strong>{state.data.author}</strong></Text>
                           </Flex>
                        )}
                     </Flex>
                  </header>

                  {state.data.image && (
                     <Image
                        radius="md"
                        src={state.data.image}
                        alt={state.data.title}
                        className='BlogDetails--image'
                        fallbackSrc="https://placehold.co/600x400?text=No+Image"
                     />
                  )}

                  <div className='BlogDetails-content-wrapper'>
                     <Stack gap="lg">
                        {postParagraphs?.map((text, index) => (
                           <Text fz='var(--fs-body)' key={index} className='BlogDetails--text'>
                              {text}
                           </Text>
                        ))}
                     </Stack>

                     {state.data.tags && state.data.tags.length > 0 && (
                        <Flex gap="xs" mt="xl" wrap="wrap">
                           {state.data.tags.map(tag => (
                              <Badge key={tag} variant="outline" color="var(--color-text-primary)">
                                 #{tag}
                              </Badge>
                           ))}
                        </Flex>
                     )}
                  </div>
               </>
            )}
         </div>
      </MainLayout>
   );
}